import { render, staticRenderFns } from "./documentsViewer.vue?vue&type=template&id=6c3a6c88&scoped=true"
import script from "./documentsViewer.vue?vue&type=script&lang=js"
export * from "./documentsViewer.vue?vue&type=script&lang=js"
import style0 from "./documentsViewer.vue?vue&type=style&index=0&id=6c3a6c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a6c88",
  null
  
)

export default component.exports